import { FlowDurationUnits, FlowMirthMessageType } from 'flow-schema';

import { api } from 'common';

import { MirthFormFields } from './FormFields';
import { mirthDefaultMessages } from './constants';
import { MirthDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { type BlockConfigProps } from '../../types';

export const mirthBlockConfig: BlockConfigProps<api.FlowDefinition.MirthBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'interfaceEngine',
  defaultConfig: {
    message: mirthDefaultMessages[FlowMirthMessageType.X12],
    path: '/',
    messageType: FlowMirthMessageType.X12,
    timeout: {
      units: FlowDurationUnits.Seconds,
      value: '45',
    },
  },
  configFields: {
    getLanguageFieldValues: (config) => {
      return {
        [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.message, config.path],
      };
    },
    schema: api.FlowDefinition.MirthBlockConfigSchema,
    FormFields: MirthFormFields,
  },
  documentationMarkdown: MirthDocumentationMarkdown,
};
